<div [ngClass]="state=='open' ? 'main_content_open' : 'main_content'">
  <p-scrollPanel [style]="{width: '100%', height: '95vh','margin-top':'7px','padding-bottom':'70px'}" #sc>
    <div class="p-d-flex p-jc-between p-ai-center p-pt-3 p-pb-3">
      <div class="page_title">Manage Subscription Plans</div>
      <div>
        <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
      </div>
    </div>

    <p-tabView>
      <!-- ═══════════════════ TAB 1: SUBSCRIPTION PLANS ═══════════════════ -->
      <p-tabPanel header="Subscription Plans">
        <p-card>
          <div class="toolbar">
            <div class="p-grid p-ai-center">
              <div class="p-col p-md-6 p-lg-12 p-jc-end d-flex">
                <button pButton pRipple type="button" label="Add Plan"
                  class="p-button-raised" style="font-size: 12px;" icon="pi pi-plus"
                  (click)="showHidePlanModalDialog('add_plan')"></button>
              </div>
            </div>
          </div>
        </p-card>
        <p-card styleClass="p-mt-3">
          <div class="row form-group">
            <div class="col-sm-12">
              <p-table #dt1 [value]="plans"
                styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
                [autoLayout]="false" [responsive]="true" [rowHover]="true">
                <ng-template pTemplate="header">
                  <tr style="font-size: small;">
                    <th style="width: 14%;">Name</th>
                    <th style="width: 15%;">Description</th>
                    <th style="width: 11%;">Monthly Price</th>
                    <th style="width: 11%;">Yearly Price</th>
                    <th style="width: 11%;">Setup Fee</th>
                    <th style="width: 6%;">Tax</th>
                    <th style="width: 24%;">Features</th>
                    <th style="width: 8%;">Action</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-plan>
                  <tr style="font-size: smaller;">
                    <td>{{plan.name}}</td>
                    <td>{{plan.description}}</td>
                    <td>{{plan.monthlyPrice}}</td>
                    <td>{{plan.yearlyPrice}}</td>
                    <td>{{plan.setupFee}}</td>
                    <td>{{plan.tax}}</td>
                    <td>
                      <div>{{getFeatureCountLabel(plan)}}</div>
                      <a *ngIf="(plan.features || []).length > 2"
                         href="javascript:void(0);"
                         style="color:#007AFF; font-size:0.75rem; display:block;"
                         (click)="showFeaturePopup($event, plan, featureOverlay)">
                        +{{(plan.features || []).length - 2}} more
                      </a>
                    </td>
                    <td class="last_border">
                      <a href="javascript:void(0);" (click)="openEditPlanDialog(plan)">
                        <i class="pi pi-pencil" style="font-size: 0.8rem;color:#007AFF"></i>
                      </a>
                      &nbsp;
                      <a href="javascript:void(0);" (click)="confirmDeletePlanDialog(plan)">
                        <i class="pi pi-trash" style="font-size: 0.8rem;color:#dc3545"></i>
                      </a>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="8">
                      <div *ngIf="isLoadingPlans" class="alignCenter">
                        <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                        </p-progressSpinner>
                      </div>
                      <p-messages *ngIf="plans?.length == 0 && !isLoadingPlans" key="planListMsg" class="alignCenter">
                        <ng-template pTemplate>
                          <i class="pi pi-copy" style="font-size: 2rem"></i>
                          <div class="p-ml-2">NO DATA FOUND</div>
                        </ng-template>
                      </p-messages>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-card>
      </p-tabPanel>

      <!-- ═══════════════════ TAB 2: PLAN FEATURES ═══════════════════ -->
      <p-tabPanel header="Plan Features">
        <p-card>
          <div class="toolbar">
            <div class="p-grid p-ai-center">
              <div class="p-col p-md-6 p-lg-12 p-jc-end d-flex">
                <button pButton pRipple type="button" label="Add Feature"
                  class="p-button-raised" style="font-size: 12px;" icon="pi pi-plus"
                  (click)="showHideFeatureModalDialog('add_feature')"></button>
              </div>
            </div>
          </div>
        </p-card>
        <p-card styleClass="p-mt-3">
          <div class="row form-group">
            <div class="col-sm-12">
              <p-table #dt2 [value]="features"
                styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
                [autoLayout]="false" [responsive]="true" [rowHover]="true">
                <ng-template pTemplate="header">
                  <tr style="font-size: small;">
                    <th style="width: 25%;">Name</th>
                    <th style="width: 35%;">Description</th>
                    <th style="width: 15%;">Amount</th>
                    <th style="width: 15%;">Amount Type</th>
                    <th style="width: 10%;">Action</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-feature>
                  <tr style="font-size: smaller;">
                    <td>{{feature.name}}</td>
                    <td>{{feature.description}}</td>
                    <td>{{feature.amount}}</td>
                    <td>{{feature.amountType}}</td>
                    <td class="last_border">
                      <a href="javascript:void(0);" (click)="openEditFeatureDialog(feature)">
                        <i class="pi pi-pencil" style="font-size: 0.8rem;color:#007AFF"></i>
                      </a>
                      &nbsp;
                      <a href="javascript:void(0);" (click)="confirmDeleteFeatureDialog(feature)">
                        <i class="pi pi-trash" style="font-size: 0.8rem;color:#dc3545"></i>
                      </a>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5">
                      <div *ngIf="isLoadingFeatures" class="alignCenter">
                        <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                        </p-progressSpinner>
                      </div>
                      <p-messages *ngIf="features?.length == 0 && !isLoadingFeatures" key="featureListMsg" class="alignCenter">
                        <ng-template pTemplate>
                          <i class="pi pi-copy" style="font-size: 2rem"></i>
                          <div class="p-ml-2">NO DATA FOUND</div>
                        </ng-template>
                      </p-messages>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-card>
      </p-tabPanel>
    </p-tabView>
  </p-scrollPanel>
</div>

<!-- ─── ADD PLAN MODAL ─── -->
<p-dialog header="Add Subscription Plan" [(visible)]="displayAddPlanModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" [maximizable]="true"
  (onHide)="clearPlanFormData()" (onShow)="showDialogMaximized($event, addPlanDialog)" #addPlanDialog>
  <p-messages key="planErrMsg" [style]="{'font-size': '12px'}"></p-messages>
  <form style="min-width: 65vw;">
    <div class="row">
      <div class="form-group col-md-6">
        <label>Plan Name<span class="symbol required"></span></label>
        <input type="text" class="form-control" name="add_planName" placeholder="e.g. STANDARD"
          [(ngModel)]="planName" />
      </div>
      <div class="form-group col-md-6">
        <label>Description</label>
        <input type="text" class="form-control" name="add_planDescription" placeholder="e.g. Standard Plan"
          [(ngModel)]="planDescription" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-3">
        <label>Monthly Price<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="add_monthlyPrice" placeholder="0.00"
          [(ngModel)]="planMonthlyPrice" min="0" />
      </div>
      <div class="form-group col-md-3">
        <label>Yearly Price<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="add_yearlyPrice" placeholder="0.00"
          [(ngModel)]="planYearlyPrice" min="0" />
      </div>
      <div class="form-group col-md-3">
        <label>Setup Fee</label>
        <input type="number" class="form-control" name="add_setupFee" placeholder="0.00"
          [(ngModel)]="planSetupFee" min="0" />
      </div>
      <div class="form-group col-md-3">
        <label>Tax</label>
        <input type="number" class="form-control" name="add_tax" placeholder="0.00"
          [(ngModel)]="planTax" min="0" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label>Info <span style="font-size:11px;color:#6c757d">(shown to customers, e.g. promo note)</span></label>
        <textarea class="form-control" name="add_info" placeholder="e.g. 1000 free SMS credits per month"
          rows="2" [(ngModel)]="planInfo"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label>Features</label>
        <p-multiSelect
          [(ngModel)]="planFeatureIds"
          [options]="featureOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Features"
          filterPlaceHolder="Search features"
          [displaySelectedLabel]="true"
          name="add_features"
          appendTo="body"
          [baseZIndex]="10001"
          [style]="{'width':'100%','font-size':'14px'}">
        </p-multiSelect>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayAddPlanModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button icon="pi pi-plus" (click)="addPlan()" label="Add" [disabled]="disabledPlan"></p-button>
  </ng-template>
  <div *ngIf="isLoadingPlans" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── EDIT PLAN MODAL ─── -->
<p-dialog #editPlanDialog header="Edit Subscription Plan" [(visible)]="displayEditPlanModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" [maximizable]="true"
  (onShow)="showDialogMaximized($event, editPlanDialog)">
  <p-messages key="planErrMsg" [style]="{'font-size': '12px'}"></p-messages>
  <form style="min-width: 65vw;">
    <div class="row">
      <div class="form-group col-md-6">
        <label>Plan Name<span class="symbol required"></span></label>
        <input type="text" class="form-control" name="edit_planName" placeholder="e.g. STANDARD"
          [(ngModel)]="planName" />
      </div>
      <div class="form-group col-md-6">
        <label>Description</label>
        <input type="text" class="form-control" name="edit_planDescription" placeholder="e.g. Standard Plan"
          [(ngModel)]="planDescription" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-3">
        <label>Monthly Price<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="edit_monthlyPrice" placeholder="0.00"
          [(ngModel)]="planMonthlyPrice" min="0" />
      </div>
      <div class="form-group col-md-3">
        <label>Yearly Price<span class="symbol required"></span></label>
        <input type="number" class="form-control" name="edit_yearlyPrice" placeholder="0.00"
          [(ngModel)]="planYearlyPrice" min="0" />
      </div>
      <div class="form-group col-md-3">
        <label>Setup Fee</label>
        <input type="number" class="form-control" name="edit_setupFee" placeholder="0.00"
          [(ngModel)]="planSetupFee" min="0" />
      </div>
      <div class="form-group col-md-3">
        <label>Tax</label>
        <input type="number" class="form-control" name="edit_tax" placeholder="0.00"
          [(ngModel)]="planTax" min="0" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label>Info <span style="font-size:11px;color:#6c757d">(shown to customers, e.g. promo note)</span></label>
        <textarea class="form-control" name="edit_info" placeholder="e.g. 1000 free SMS credits per month"
          rows="2" [(ngModel)]="planInfo"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label>Features</label>
        <p-multiSelect
          [(ngModel)]="planFeatureIds"
          [options]="featureOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Features"
          filterPlaceHolder="Search features"
          [displaySelectedLabel]="true"
          name="edit_features"
          appendTo="body"
          [baseZIndex]="10001"
          [style]="{'width':'100%','font-size':'14px'}">
        </p-multiSelect>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayEditPlanModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button icon="pi pi-save" (click)="editPlan()" label="Save" [disabled]="disabledPlan"></p-button>
  </ng-template>
  <div *ngIf="isLoadingPlans" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── ADD FEATURE MODAL ─── -->
<p-dialog header="Add Feature" [(visible)]="displayAddFeatureModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" [maximizable]="true"
  (onHide)="clearFeatureFormData()" (onShow)="showDialogMaximized($event, addFeatureDialog)" #addFeatureDialog>
  <p-messages key="featureErrMsg" [style]="{'font-size': '12px'}"></p-messages>
  <form style="min-width: 50vw;">
    <div class="row">
      <div class="form-group col-md-12">
        <label>Feature Name<span class="symbol required"></span></label>
        <input type="text" class="form-control" name="add_featureName" placeholder="e.g. monthly_message_credits"
          [(ngModel)]="featureName" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Description</label>
        <textarea class="form-control" name="add_featureDescription" placeholder="Enter description"
          rows="2" [(ngModel)]="featureDescription"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label>Amount</label>
        <input type="number" class="form-control" name="add_featureAmount" placeholder="e.g. 1000"
          [(ngModel)]="featureAmount" />
      </div>
      <div class="form-group col-md-6">
        <label>Amount Type<span class="symbol required"></span></label>
        <select [(ngModel)]="featureAmountType" class="form-control" name="add_featureAmountType" style="height: 34px;">
          <option *ngFor="let opt of amountTypeOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayAddFeatureModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button icon="pi pi-plus" (click)="addFeature()" label="Add" [disabled]="disabledFeature"></p-button>
  </ng-template>
  <div *ngIf="isLoadingFeatures" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── EDIT FEATURE MODAL ─── -->
<p-dialog #editFeatureDialog header="Edit Feature" [(visible)]="displayEditFeatureModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="true" [maximizable]="true"
  (onShow)="showDialogMaximized($event, editFeatureDialog)">
  <p-messages key="featureErrMsg" [style]="{'font-size': '12px'}"></p-messages>
  <form style="min-width: 50vw;">
    <div class="row">
      <div class="form-group col-md-12">
        <label>Feature Name<span class="symbol required"></span></label>
        <input type="text" class="form-control" name="edit_featureName" placeholder="e.g. monthly_message_credits"
          [(ngModel)]="featureName" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Description</label>
        <textarea class="form-control" name="edit_featureDescription" placeholder="Enter description"
          rows="2" [(ngModel)]="featureDescription"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label>Amount</label>
        <input type="number" class="form-control" name="edit_featureAmount" placeholder="e.g. 1000"
          [(ngModel)]="featureAmount" />
      </div>
      <div class="form-group col-md-6">
        <label>Amount Type<span class="symbol required"></span></label>
        <select [(ngModel)]="featureAmountType" class="form-control" name="edit_featureAmountType" style="height: 34px;">
          <option *ngFor="let opt of amountTypeOptions" [value]="opt.value">{{opt.label}}</option>
        </select>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" (click)="displayEditFeatureModal = false" label="Cancel"
      styleClass="p-button-danger p-button-text"></p-button>
    <p-button icon="pi pi-save" (click)="editFeature()" label="Save" [disabled]="disabledFeature"></p-button>
  </ng-template>
  <div *ngIf="isLoadingFeatures" class="progressLayout">
    <div class="progressContainer">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<!-- ─── DELETE CONFIRMATION ─── -->
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" [style]="{width:'45vw'}">
</p-confirmDialog>

<!-- ─── FEATURES OVERLAY PANEL ─── -->
<p-overlayPanel #featureOverlay appendTo="body" [showCloseIcon]="false">
  <ng-template pTemplate>
    <ul style="margin:0; padding:0 0 0 16px; max-height:180px; overflow-y:auto; min-width:160px; font-size:12px;">
      <li *ngFor="let f of activeFeatures" style="padding:2px 0;">{{f.name}}</li>
    </ul>
  </ng-template>
</p-overlayPanel>
